import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { productsData } from '../data';

const Products = () => {
  const theme = useTheme();
  const oliveColor = theme.palette.brand?.altamiraOlive || '#2B3A1D';

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Plan de Inversión
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Bienestar Village
        </Box>
      </Box>
      <Grid container spacing={4}>
        {productsData.map((item, i) => (
          <Grid item xs={12} sm={6} md={4} key={item.id}>
            <Card
              elevation={2}
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                borderTop: `5px solid ${oliveColor}`,
              }}
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              {item.image &&
                (typeof item.image === 'string' ? (
                  <Box
                    component="img"
                    src={item.image}
                    alt={item.imageAlt || ''}
                    sx={{
                      width: '100%',
                      height: 200,
                      objectFit: 'cover',
                      objectPosition: item.objectPosition || 'center',
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      width: '100%',
                      height: 200,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'hidden',
                    }}
                  >
                    {React.createElement(item.image, { width: 260, height: 180 })}
                  </Box>
                ))}
              <CardContent sx={{ flexGrow: 1, pb: 3 }}>
                <Typography
                  variant="overline"
                  color="primary"
                  fontWeight={600}
                  display="block"
                  gutterBottom
                >
                  {item.product}
                </Typography>
                <Typography variant="h6" gutterBottom fontWeight={700}>
                  {item.title}
                </Typography>
                {item.subtitle && (
                  <Typography variant="body2" color="textSecondary" gutterBottom>
                    {item.subtitle}
                  </Typography>
                )}
                <Typography
                  variant="h6"
                  sx={{ my: 1 }}
                  color="primary"
                  fontWeight={700}
                >
                  {item.investment}
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                  Impacto:
                </Typography>
                <Box component="ul" sx={{ m: 0, pl: 2.5, mt: 0.5 }}>
                  {item.impacts.map((impact, j) => (
                    <Typography
                      key={j}
                      component="li"
                      variant="body2"
                      color="textSecondary"
                      sx={{ mb: 0.5 }}
                    >
                      {impact}
                    </Typography>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Products;
